import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  VIDEO: '[data-fragment="ContentVideo.video"]',
  PLAY: '[data-fragment="ContentVideo.play"]',
};

class ContentVideo extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      videoPlaying: false,
    };
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
  }
  didMount() {
    this.on('click', fragments.PLAY, this.play);
    this.video = this.element.querySelector(fragments.VIDEO);
    this.video.addEventListener('ended', this.videoEnded);
    this.video.addEventListener('click', this.pause);
    this.playBtn = this.element.querySelector(fragments.PLAY);
  }
  play = () => {
    this.video.play();
    this.setState({
      videoPlaying: true,
    });
  };
  pause = () => {
    if (this.state.videoPlaying) {
      this.video.pause();
      this.setState({
        videoPlaying: false,
      });
    } else {
      this.play();
    }
  };
  videoEnded = () => {
    this.setState({
      videoPlaying: false,
    });
    this.video.currentTime = 0;
  };
  willUnMount() {}
  update() {
    const { videoPlaying } = this.state;
    classNames(this.element, { 'content-video--playing': videoPlaying });
  }
}

export default ContentVideo;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ContentVideo.js